import PrimaryButton from "@/Components/UI/Forms/PrimaryButton";
import SecondaryButton from "@/Components/UI/Forms/SecondaryButton";
import Modal, { ModalProps } from "@/Components/UI/Modal";
import { ReactNode } from "react";

export type ConfirmationModalProps = ModalProps & {
    title: ReactNode;
    content: ReactNode;
    confirmText?: string;
    cancelText?: string;
    processing?: boolean;
    onConfirm: () => void;
    onCancel: () => void;
    dataTestId?: string;
};

export default function ConfirmationModal({
    title,
    content,
    confirmText = "Confirm",
    cancelText = "Cancel",
    onConfirm,
    onCancel,
    processing,
    dataTestId,
    ...props
}: ConfirmationModalProps) {
    return (
        <Modal {...props}>
            <div
                data-testid={dataTestId}
                className="flex h-full max-h-[80vh] flex-col items-stretch p-6 sm:p-8"
            >
                <div
                    data-testid="modal-title"
                    className="pb-2 text-left text-2xl font-bold"
                >
                    {title}
                </div>
                <div
                    data-testid="modal-content"
                    className="grow overflow-y-auto"
                >
                    {content}
                </div>
                <div className="flex flex-col justify-end gap-3 pt-6 sm:flex-row">
                    <PrimaryButton
                        onClick={onConfirm}
                        disabled={processing}
                        className={"grow justify-center py-3 sm:order-2 sm:w-0"}
                    >
                        {confirmText}
                    </PrimaryButton>
                    {cancelText && (
                        <SecondaryButton
                            data-testid="go-back-button"
                            onClick={onCancel}
                            className={"grow justify-center py-3 sm:w-0"}
                        >
                            {cancelText}
                        </SecondaryButton>
                    )}
                </div>
            </div>
        </Modal>
    );
}
